import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="bg-forest py-5 sm:py-7" data-id="element-138" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-139" data-mp="38x5by9sclgvr">
        <h2 className="text-center text-2xl leading-none text-white sm:text-4xl" data-id="element-140" data-mp="2uyx7zhww9fb3">
          Does this sound <span className="text-gold" data-id="element-141" data-mp="2yyzblwm6wit0">familiar?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-142" data-mp="2z1ljjxczt0br">
          You notice yellowing leaves, unusual discoloration, poor growth, or damaged leaf
          margins—but nutrient deficiencies, toxicities, soil conditions, and environmental
          stress can produce similar symptoms, making it difficult to identify the actual
          problem.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-143" data-mp="229qamm96evrf">
          {painPoints.map(point => <article key={point.title} className="rounded-lg border-l-4 border-gold bg-forest-deep p-3 sm:p-4" data-id="element-144" data-mp="2792vx2kefurw">
              <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-145" data-mp="3rl7ne5lfw9z6">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-146" data-mp="3nl5tiily4kug">{point.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}